import { Stack, Typography } from "@mui/material";
import React from "react";

import StepperItem from "../../../../Components/CustomerStepper/StepperItem";

export interface IInterestsStep {
  /** The form elements which will allow selection of the interested areas. */
  AreaOfInterestPickers: React.FC[];
}

/** The interest step that needs to be configured with an areas of interest picker. */
const InterestsStep: React.FC<IInterestsStep> = ({ AreaOfInterestPickers }) => {
  return (
    <Stack spacing={1}>
      <StepperItem>
        <Typography variant="stageDirection">
          Address the following questions naturally through the flow of the conversation.
        </Typography>
      </StepperItem>
      <StepperItem>
        <Typography variant="body2">Thank you! And what areas of the body are you interested in Treating?</Typography>
      </StepperItem>
      {AreaOfInterestPickers.map((AreaOfInterestPicker, index) => {
        return (
          <StepperItem key={index}>
            <AreaOfInterestPicker />
          </StepperItem>
        );
      })}
      <StepperItem>
        <Typography variant="body2">
          We are able to offer great results in those areas, you definitely called the right place! To help us prepare
          for your consultation, could you provide your height and weight?
        </Typography>
      </StepperItem>
    </Stack>
  );
};

export default InterestsStep;
